export default "__VITE_ASSET__C7XdjlR6__"